import './App.scss';

function App() {
  return (
    <div className="App">
      <div className='myPage'> COMING SOON! </div>
      <div className='myPagee'> COMING SOON! </div>
    </div>
  );
}

export default App;
